/**
 * ч.1080 → ч.1405 (рішення власника): у режимі «Користувач» без доступних організацій у поточному
 * акаунті — підказка замість меню і перемикач на «Бізнес» (повне меню сервісу для власного бізнесу у
 * ВЛАСНОМУ акаунті). Створювати організацію тут не пропонуємо: у режимі «Бізнес» це робиться
 * звичайним шляхом через меню.
 */
import { useSetAccountMode } from '@/hooks/useAccountMode';

export default function AddOrganizationCta({ variant = 'header' }: {
  variant?: 'header' | 'page';
}) {
  const toOwner = useSetAccountMode();
  const button = (
    <button type="button" disabled={toOwner.isPending} onClick={() => toOwner.mutate('OWNER')}
      title="Режим «Бізнес»: одразу повне меню сервісу для власного бізнесу у вашому акаунті">
      я веду власний бізнес — режим «Бізнес»
    </button>
  );
  if (variant === 'header') {
    return (
      <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span className="app__onboarding-hint">Немає доступних організацій</span>
        {button}
      </span>
    );
  }
  return (
    <div>
      <p style={{ color: 'var(--muted)', marginTop: 0 }}>
        Ви в режимі «Користувач»: працюєте в акаунтах, куди вас запросили. У цьому акаунті вам ще не
        надали доступ до організації — щойно власник акаунта це зробить, зʼявляться меню, документи і звіти.
      </p>
      <p style={{ color: 'var(--muted)' }}>
        Ведете власний бізнес? Перемкніть режим на «Бізнес» — відкриється ваш акаунт із повним меню,
        і ви створите свою організацію. Потрібні лише електронні документи — режим «ЕДО» (іконка
        документа у шапці). Режим можна змінити будь-коли: «Обліковий запис» → «Облікові дані».
      </p>
      {button}
    </div>
  );
}
